import * as csTools from '@cornerstonejs/tools';

import { eventTarget } from '@cornerstonejs/core';

const { Enums: csToolsEnums } = csTools;

const _autoAcceptAnnotationInterpolationHandler = evt => {
  const { element } = evt.detail;
  csTools.utilities.contours.acceptAutogeneratedInterpolations(element, {});
};

export const setUpAnnotationEventHandlers = (): [() => void] => {
  eventTarget.addEventListener(
    csToolsEnums.Events.ANNOTATION_INTERPOLATION_PROCESS_COMPLETED,
    _autoAcceptAnnotationInterpolationHandler
  );

  const annotationInterpolationProcessCompletedUnsubscribe = () => {
    eventTarget.removeEventListener(
      csToolsEnums.Events.ANNOTATION_INTERPOLATION_PROCESS_COMPLETED,
      _autoAcceptAnnotationInterpolationHandler
    );
  };

  return [annotationInterpolationProcessCompletedUnsubscribe];
};
